import React from "react";
import { connect } from "react-redux";
import ExceptionCard from "./ExceptionCard"
import AddIcon from "../UIComponents/AddIcon";
import { getExceptionList, deleteExceptionList } from "../Actions/ExceptionManagementAPI";
import { confirmAlert } from 'react-confirm-alert';

class ExceptionManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: '',
        PageNumber: 1,
        PageSize: 25
      },
    }
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props.dispatch({ type: 'SubBannerTitle', data: "Exception Management" });
    this.props.dispatch(getExceptionList(this.state.searchData));
  }

  handleInputChange(e) {
    this.state.searchData.Name = e.target.value;
    if (e.target.value === "") {
      this.props.dispatch(getExceptionList(this.state.searchData));
    }
    this.setState({});
  }

  SearchException(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(getExceptionList(this.state.searchData));
  }

  ClearInput = () => {
    this.state.searchData.Name = "";
    this.props.dispatch(getExceptionList(this.state.searchData));
    this.setState({});
  }

  DeletePopup(item) {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteExceptionData(item)
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }

  DeleteExceptionData(item) {
    let listitem = {
      exceptionId: item.exceptionId,
      name: item.name,
      type: item.type,
      isDeleted: true,
      modifiedBy: ''
    };
    this.props.dispatch(deleteExceptionList(listitem));
    this.state.searchData.Name = "";
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }

  render() {
    const { showSidePane, ExceptionList } = this.props;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
                        </button>
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                          Exception Management
                        </h5>
                        <div className="m-1 flex"
                          onClick={() =>
                            this.ShowSidePanel()
                          }>
                          <span className="card-title m-auto">Add</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-6 "}>
                          <label className="form-label">Name</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="exceptionName"
                            placeholder="Name"
                            value={this.state.searchData.Name}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={showSidePane ? "col-lg-6 py-3" : "col-lg-6 py-3"}>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchException(1)}
                            >
                              {" "}
                              Search{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              Clear{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ExceptionList ? (
                <ExceptionCard
                  arraylist={ExceptionList.data}
                  pageSize={ExceptionList.pagination.pageSize}
                  currentPage={ExceptionList.pagination.currentPage}
                  totalRecords={ExceptionList.pagination.totalcount ? ExceptionList.pagination.totalcount : 0}
                  DeleteException={item => this.DeletePopup(item)}
                  setUpdatedState={(value) => this.SearchException(value)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  ShowSidePanel = () => {
    //  this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Management/AddException`);
  };
}



function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ExceptionList: state.MasterScreenReducer.ExceptionList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExceptionManagement);
